var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AAC"},[_c('PublicScore',{attrs:{"logo":_vm.Logo5,"type":'aac',"color":'#36b9bf'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }